<template>
    <div>
        <Header backButton></Header>
        <div class="inscription">
            <img class="logo" alt="Quest Me logo" src="../assets/logo.png">
            <div class="contenu pt-16 indexUp">
                <p class="text-5xl mb-10 leading-custom">
                    Bienvenue sur
                    <span class="sunshiney">Quest Me</span> !
                </p>
                <p class="text-2xl mb-10 leading-custom">Votre aventure commence ici ✌️ !</p>
                <p
                    class="text-2xl leading-custom"
                >Le défi de la rencontre s'ouvre à vous, bonne chance 🤞</p>
            </div>
            <div class="groupBouton mt-32 indexUp">
                <BoutonFacebook link="/facebook" text="Soon"></BoutonFacebook>
                <Bouton link="/inscription-histoire" text="Basic" white></Bouton>
            </div>
        </div>
    </div>
</template>

<script>
import Bouton from "@/components/boutons/Bouton.vue";
import Header from "@/components/Header.vue";
import BoutonFacebook from "@/components/boutons/BoutonFacebook.vue";

export default {
    name: "inscription",
    components: {
        Bouton,
        BoutonFacebook,
        Header
    }
};
</script>

<style scoped lang="scss">
.inscription {
    height: 100%;
    margin-top: 60px;
}
.logo {
    position: fixed;
    top: -50px;
    left: -65px;
    width: 80%;
    opacity: 0.3;
}
.contenu {
    margin: 0 34px;
    text-align: left;
}
.groupBouton {
    width: 100%;
    bottom: 40px;
}
</style>